<div class="full-width">
  <ng-container *ngFor="let task of tasks; trackBy: trackByTaskId">
    <div class="row no-gutters mb-1">
      <div class="col-12">
        <div class="full-width display-flex">
          <checklist-task
            class="full-width"
            [currentChecklist]="currentChecklist"
            [currentChecklistTemplate]="currentChecklistTemplate"
            [task]="task"
            [disabled]="disabled"
            [precheck]="precheck"
            (updateTask)="updateTask($event)"
            (taskValueChanged)="updateTaskConditions($event)"
            (checkShared)="checkShared.emit($event)"
            (itemCountChanged)="onItemCountChanged(task, $event)"
          >
          </checklist-task>
        </div>
      </div>
    </div>
  </ng-container>
</div>
